import { onAuthStateChanged } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import './App.css';
import { UserProvider } from './Context/UserContext';
import { auth } from './firebase';
import { getUserDoc } from './Requests/firebaseFirestore';
import ErrorPage from './Routes/ErrorPage';
import EventFormPage from './Routes/InfoPages/EventFormPage';
import EventInvitationFormPage from './Routes/Invitations/EventInvitationFormPage';
import EventsPage from './Routes/InfoPages/EventsPage';
import ExhibitorsPage from './Routes/InfoPages/ExhibitorsPage';
import GroupsPage from './Routes/InfoPages/GroupsPage';
import GuestsPage from './Routes/InfoPages/GuestsPage';
import HomePage from './Routes/HomePage';
import InfoPage from './Routes/InfoPage';
import NewExhibitorPage from './Routes/NewUserPage/NewExhibitorPage';
import NewUserPage from './Routes/NewUserPage';
import ProfilePage from './Routes/InfoPages/ProfilePage';
import SignInPage from './Routes/SignInPage';
import StaffPage from './Routes/InfoPages/StaffPage';
import UsersPage from './Routes/InfoPages/UsersPage';
import ThanksPage from './Routes/Invitations/ThanksPage';
import FormSentPage from './Routes/Invitations/FormSentPage';
import EventMails from './Routes/InfoPages/EventMails';
import GroupGuestsPage from './Routes/InfoPages/GroupGuestsPage';
import InvitePage from './Routes/InfoPages/InvitePage';
import AddToGroup from './Routes/AddToGroup';
import { signOut } from './Requests/firebaseAuth';
import NewOrganizerPage from './Routes/NewUserPage/NewOrganizerPage';
import ForgotPassword from './Routes/ForgotPassword';
import ResetPassword from './Routes/ResetPassword';
import EventPage from './Routes/InfoPages/EventPage';
import NewStaffPage from './Routes/NewUserPage/NewStaffPage';
import {url} from "./Requests/urls"

function App() {
  const [user, setUser] = useState('checking')
  const [seeAs, setSeeAs] = useState('')
  //const [userInfo, setUserInfo] = useState(null)
  const getUserInfo = async (newUser) => {
    const userInfo = await getUserDoc(newUser.uid)
    if(userInfo.inactive){
      await signOut()
      alert('tu cuenta esta desactivada')
    }else{
      setUser({...newUser, ...userInfo})
    }
  }
  useEffect(()=>{
    onAuthStateChanged(auth, newUser=>{
      if (newUser) {
        getUserInfo(newUser)
      } else {
        setUser(false)
      }
    })
  },[])

  return (
    <>
    <UserProvider value={{user:user, seeAs:seeAs, setSeeAs:setSeeAs, url:url.web}}>
      <BrowserRouter>
        <Routes>
          <Route element={<HomePage/>} path='/'/>
          <Route element={<InfoPage/>} path=':role/'>
            <Route element={<EventsPage/>} path='events'/>
            <Route element={<EventPage/>} path='event/:eventId'/>
            <Route element={<EventFormPage/>} path='form'/>
            <Route element={<EventMails/>} path='emails'/>
            <Route element={<ExhibitorsPage/>} path='exhibitors'/>
            <Route element={<GroupsPage/>} path='groups'/>
            <Route element={<GroupGuestsPage/>} path='group/:groupId'/>
            <Route element={<UsersPage/>} path='users'/>
            <Route element={<ProfilePage/>} path='profile'/>
            <Route element={<StaffPage/>} path='staff'/>
            <Route element={<GuestsPage/>} path='guests'/>
            <Route element={<InvitePage/>} path='invite'/>
          </Route>
          <Route element={<NewUserPage/>} path='/newuser'>
            <Route element={<NewExhibitorPage/>} path='exhibitor/:inviteId'/>
            <Route element={<NewOrganizerPage/>} path='organizer/:inviteId'/>
            <Route element={<NewStaffPage/>} path='staff/:inviteId'/>
          </Route>
          <Route element={<SignInPage/>} path='/signin'/>
          <Route element={<EventInvitationFormPage/>} path='/invitationform/:eventId'/>
          <Route element={<FormSentPage/>} path='formsent' />
          <Route element={<ThanksPage/>} path='/emailconfirmed/:guestId'/>
          <Route element={<AddToGroup/>} path='/addtogroup/:guestId'/>
          <Route element={<ForgotPassword/>} path='/forgotpassword'/>
          <Route element={<ResetPassword/>} path='/resetpassword'/>
          <Route element={<ErrorPage/>} path='*' />
        </Routes>
      </BrowserRouter>
    </UserProvider>
    </>
  );
}

export default App;
